(function () {
  function init(root) {
    if (!root || root.dataset.ccHomeV8SearchInit === "1") return;
    root.dataset.ccHomeV8SearchInit = "1";

    var form = root.querySelector(".cc-home-v8__search-form");
    var input = root.querySelector("[data-cc-home-v8-search-input]");
    var clearBtn = root.querySelector("[data-cc-home-v8-search-clear]");
    var tags = root.querySelectorAll("[data-cc-home-v8-search-tag]");
    if (!form || !input) return;

    var selected = new Set();

    function parseInputTerms() {
      return String(input.value || "")
        .split(/\s+/)
        .map(function (t) {
          return t.trim();
        })
        .filter(Boolean);
    }

    function setTagState(tag, on) {
      tag.classList.toggle("is-active", on);
      tag.setAttribute("aria-pressed", on ? "true" : "false");
    }

    function syncFromInput() {
      selected.clear();
      parseInputTerms().forEach(function (t) {
        selected.add(t.toLowerCase());
      });
      tags.forEach(function (tag) {
        var q = (tag.getAttribute("data-q") || "").trim().toLowerCase();
        setTagState(tag, Boolean(q && selected.has(q)));
      });
    }

    function syncInputFromSelected() {
      input.value = Array.from(selected).join(" ");
      syncClear();
    }

    function syncClear() {
      if (!clearBtn) return;
      clearBtn.hidden = String(input.value || "").trim() === "";
    }

    tags.forEach(function (tag) {
      tag.addEventListener("click", function () {
        var q = (tag.getAttribute("data-q") || "").trim();
        if (!q) return;
        var key = q.toLowerCase();
        if (selected.has(key)) {
          selected.delete(key);
        } else {
          selected.add(key);
        }
        syncInputFromSelected();
        tags.forEach(function (t) {
          var k = (t.getAttribute("data-q") || "").trim().toLowerCase();
          setTagState(t, Boolean(k && selected.has(k)));
        });
      });
    });

    if (clearBtn) {
      clearBtn.addEventListener("click", function () {
        input.value = "";
        selected.clear();
        tags.forEach(function (tag) {
          setTagState(tag, false);
        });
        syncClear();
        input.focus();
      });
    }

    input.addEventListener("input", function () {
      syncFromInput();
      syncClear();
    });

    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && typeof form.requestSubmit === "function") {
        e.preventDefault();
        form.requestSubmit();
      }
    });

    syncFromInput();
    syncClear();
  }

  function boot() {
    document.querySelectorAll(".cc-home-v8__search").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
